import React from 'react';
interface MathsBadgeProps {
  imageUrl: string;
  altText: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}
export function MathsBadge({
  imageUrl,
  altText,
  size = 'medium',
  className = ''
}: MathsBadgeProps) {
  const sizeClasses = {
    small: 'w-12 h-12',
    medium: 'w-16 h-16',
    large: 'w-20 h-20'
  };
  return <div className={`${sizeClasses[size]} rounded-full overflow-hidden shadow-md transform rotate-3 hover:rotate-0 transition-all duration-300 ${className}`} data-id="element-493">
      <img src={imageUrl} alt={altText} className="w-full h-full object-cover" data-id="element-494" />
    </div>;
}